var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Delete",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 366.28 524.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_47",
    "data-name": "Layer 47"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "303.76 107.44 278.22 390.6 75.21 390.6 53.19 107.44 117.93 107.44 134.29 58.56 221.8 57.24 238.59 103.48"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.53,51.09a8.2,8.2,0,0,1,7.78,5.61l14.54,43.61H325.7a8.21,8.21,0,0,1,0,16.41H311.35l-24,276.88a8.2,8.2,0,0,1-8.17,7.49H76.87a8.2,8.2,0,0,1-8.17-7.49l-24-276.88H30.39a8.21,8.21,0,0,1,0-16.41h78.85L123.78,56.7a8.2,8.2,0,0,1,7.78-5.61Zm70.35,65.63H61.21l23.19,268H271.69Zm-116,41.06a8.37,8.37,0,0,1,7.36,8.16V335.47a8.21,8.21,0,0,1-16.41,0V165.94a8.35,8.35,0,0,1,8.21-8.21Zm61.73,0h.84a8.21,8.21,0,0,1,7.66,8.71L238.18,336a8.2,8.2,0,0,1-16.37-1.06l10.94-169.53c.49-4.64,3.43-7.06,7.87-7.67Zm-125.16,0a8.37,8.37,0,0,1,7.88,7.67l10.94,169.53A8.2,8.2,0,0,1,117.91,336L107,166.46a8.21,8.21,0,0,1,7.66-8.71ZM218.62,67.5H137.47l-10.93,32.81h103Zm0,0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.18c5ef3866c9e974d86bd79822d3f0d8.svg";
export { ForwardRef as ReactComponent };